/*global jsConfig*/
jsConfig.infiniteScroll && jQuery(function ($) {
    'use strict';

    var $spinner;
    var $apageList;
    var templates;
    var templateIndex = 0;
    var loadedPagesCount = 1;
    var trackingMinTime = jsConfig.infiniteScroll.trackingMinTime;
    var trackingTimeoutId = -1;
    var debugScrolling = false; // If enabled will show debug logs

    activate();

    ////////////////////

    function activate() {
        $('body').addClass('infinite-scroll');

        $apageList = $('.apage-list');
        $spinner = $('<div class="infinite-scroll__spinner"><span class="infinite-scroll__spinner__anchor"></span></div>');

        var $anchor = $spinner
            .insertAfter($apageList)
            .find('.infinite-scroll__spinner__anchor');

        if ($anchor.sonar() || $anchor.offset().top < 0) {
            // Offset will be less than 0 if there are no entries
            // Nothing to scroll. Anchor is already visible.
            endReached();
        } else {
            listenForTracking();
            $anchor.on('scrollin', loadMore);
        }
    }

    function loadMore() {
        nextPageContent().then(function (content) {
            $(content)
                .appendTo($apageList) // Add on page
                .find('.lazy-load-image').lazyLoadImage();

            // Track newly loaded entries
            MW.modules.rapid.trackElements($apageList);

            setTimeout(listenForTracking, 0);
            templateIndex++;
        }, endReached);
    }

    function endReached() {
        $spinner.remove();
    }

    function initializePages() {
        if (!templates) {
            templates = {};

            $('.apage-list__page').each(function () {
                templates[this.getAttribute('data-page-index')] = this;
            });
        }
    }

    function nextPageContent() {
        var def = $.Deferred();

        initializePages();
        var templateDom = templates[templateIndex];

        if (templateDom) {
            def.resolve(templateDom.innerHTML);
            $(templateDom).remove();
        } else {
            // Check if there is another page
            var nextPageUrl = $('.pagination a[rel="next"]').attr('href');

            if (nextPageUrl) {
                requestRemotePage(nextPageUrl).then(nextPageContent, def.reject);
            } else {
                def.reject(); // Nope. That's really the end. No more pages to load
            }
        }

        function requestRemotePage(pageUrl) {
            if (loadedPagesCount >= jsConfig.infiniteScroll.maxPages) {
                return $.Deferred().reject().promise(); // Don't load more pages
            }

            return $.get(pageUrl, {inf_scroll: 1}).then(
                function (pageHtml) {
                    var bodyHtml = '<div id="body-mock">' + pageHtml.replace(/^[\s\S]*<body.*?>|<\/body>[\s\S]*$/ig, '') + '</div>';
                    var $body = $(bodyHtml);

                    $('.pagination').replaceWith($body.find('.pagination'));

                    loadedPagesCount++;
                    // Reset templates state
                    templateIndex = 0;
                    templates = null;

                    var $entries = $body.find('.apage-list').children();

                    // Ad blockers breaks lazyLoadImage so we need a timeout
                    setTimeout(function () {
                        $entries.find('.lazy-load-image').lazyLoadImage();
                    }, 0);

                    $entries.appendTo('.apage-list');
                }
            );
        }

        return def.promise();
    }

    function listenForTracking() {
        var scrollSize = jsConfig.infiniteScroll.scrollTrackingSize;

        if (scrollSize) {
            var $allArticles = $apageList.find('article');
            var $scrollArticles = $allArticles.filter(function(index, articleElement) {
                return index > 0 && index % scrollSize === 0 && !articleElement.hasAttribute('data-scroll-reached');
            });

            if (debugScrolling) {
                $scrollArticles.css('background-color', '#fff6aa');
            }

            $('<div class="alt__scroll-tracking"></div>')
                .appendTo($scrollArticles)
                .on('scrollin.tracking', scrolledToTrackingArticle);
        } else {
            console.error('Missing "scrollTrackingSize" config.');
        }
    }

    function scrolledToTrackingArticle() {
        // jshint validthis:true
        var $article = $(this).closest('article');

        if (hasPendingTracking()) {
            // User didn't stay enough. Don't track this page
            clearTimeout(trackingTimeoutId);

            if (debugScrolling) {
                console.error('Cancel tracking for previous article.');
            }
        }

        // jshint validthis:true
        trackingTimeoutId = setTimeout(trackArticle.bind($article[0]), trackingMinTime);

        if (debugScrolling) {
            console.log('Scrolled to:', articleTitle($article));
        }

        // Mark as passed
        $article.attr('data-scroll-reached', 'true');
        $article.find('.alt__scroll-tracking').off('scrollin.tracking');
    }

    function trackArticle() {
        // jshint validthis:true
        var $article = $(this);
        trackingTimeoutId = -1;

        if (debugScrolling) {
            console.info('Track article:', articleTitle($article));
        }

        MW.events.publish('infinite_scroll');
    }

    function hasPendingTracking() {
        return trackingTimeoutId >= 0;
    }

    function articleTitle($article) {
        return $article.find('.post-title').text().trim();
    }

}); // jshint ignore:line
